










import { Component, Vue, Prop } from 'vue-property-decorator';
import Progress from './components';
import { TestResultParam as ISmartStatParam, StringOrNumber } from './types';

@Component({
  components: {
    Progress,
  },
})
export default class SmartStatParam extends Vue implements ISmartStatParam {
  @Prop({ type: String, default: '' })
  readonly text!: string;

  @Prop({ type: [String, Number], default: '' })
  readonly value!: StringOrNumber;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/smart/components/item/SmartStatItem.vue